import React, { useState } from 'react';
import { ForgotPasswordPNG } from '../../../assets';
import { generateMessageByCampaignById } from '../../../core/requests/requests';
import { CampaignByIdPreviewProps } from './campaignModels';

const CampaignByIdPreview: React.FC<CampaignByIdPreviewProps> = ({
  currentCampaignId,
  campaignInitialMessage,
}) => {
  const [generatedMessage, setGeneratedMessage] = useState<string>('');
  const [generatingMessage, setGeneratingMessage] = useState<boolean>(false);

  const handleGenerateInitialMessage = async () => {
    try {
      if (currentCampaignId) {
        setGeneratingMessage(true);
        const { data } = await generateMessageByCampaignById(currentCampaignId);
        if (data) {
          setGeneratedMessage(data.toString());
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setGeneratingMessage(false);
    }
  };

  return (
    <div className="campaign-by-id__preview-container">
      <span className="campaign-by-id__preview-title">Preview</span>
      <div className="campaign-by-id__preview-content">
        <div className="campaign-by-id__preview-content-item">
          {campaignInitialMessage ? (
            <span className="campaign-by-id__preview-content-text">
              {campaignInitialMessage}
            </span>
          ) : (
            <>
              {generatedMessage?.length > 0 && !generatingMessage ? (
                <div className="d-flex-start-start w-100">
                  <span className="campaign-by-id__preview-content-text">
                    {generatedMessage}
                  </span>
                  {/*<div className="d-flex-center w-100">
                    <div
                      className="btn-convert-primary mt-1rem"
                      onClick={handleGenerateInitialMessage}
                    >
                      <span>Refresh</span>
                    </div>
                  </div>*/}
                </div>
              ) : (
                <>
                  {generatingMessage ? (
                    <div className="btn-text-preview-primary mt-2_5rem mr-1_5rem">
                      <div className="loader"></div>
                    </div>
                  ) : (
                    <div
                      className="btn-text-preview-primary mt-2_5rem mr-1_5rem"
                      onClick={handleGenerateInitialMessage}
                    >
                      <span>Preview message</span>
                    </div>
                  )}
                </>
              )}
            </>
          )}
        </div>
        <div className="campaign-by-id__preview-content-image">
          <img src={ForgotPasswordPNG} alt="" />
        </div>
      </div>
    </div>
  );
};

export default CampaignByIdPreview;
